import { CreateEventPayload0301 } from '@graphql/generated';
import { useQueryParams } from '@shared/utils/hooks/useQueryParams';
import { SinglePhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';
import { useCallback } from 'react';

type WebsiteDesignColors = {
  linkAndButton?: string;
  artBackground?: string;
  artFont?: string;
  pageBackground?: string;
  pageFont?: string;
};

type WebsiteDesignSettings = {
  colors?: WebsiteDesignColors;
  pageTransparency?: boolean;
  pageShadow?: boolean;
  photoPresentationLayout?: SinglePhotoPresentationLayout;
  fontPackName?: string;
  isBlankTemplate?: boolean;
};

export const getWebsiteDesignSettings = (encodedSettings: string): WebsiteDesignSettings | null => {
  try {
    return JSON.parse(Buffer.from(encodedSettings, 'base64').toString('utf-8')) as WebsiteDesignSettings;
  } catch (e) {
    console.error('Error parsing Website Design Settings', e);
    return null;
  }
};

export const useWebsiteDesignSettingsQueryParam = () => {
  const { wds: websiteDesignSettings } = useQueryParams();

  const appendWebsiteDesignSettings = useCallback(
    (payload: CreateEventPayload0301) => {
      const decodedSettings = getWebsiteDesignSettings(websiteDesignSettings as string);
      if (decodedSettings) {
        const { colors, pageTransparency, pageShadow, photoPresentationLayout, fontPackName } = decodedSettings;
        payload.websiteDesignSettings = {
          colors: {
            linkAndButtonColor: colors?.linkAndButton,
            artBackgroundColor: colors?.artBackground,
            artFontColor: colors?.artFont,
            pageBackgroundColor: colors?.pageBackground,
            pageFontColor: colors?.pageFont
          },
          pageTransparency,
          pageShadow,
          welcomePhotoPresentationLayout: photoPresentationLayout,
          fontPackName
        };
      }
    },
    [websiteDesignSettings]
  );

  return { websiteDesignSettings, appendWebsiteDesignSettings };
};
